export const MAIN_PATH = '/';

export const WORKSPACE_PATH = '/workspace/:workspaceUname';

export const ADMIN_PATH = '/admin';
export const CONSULTANT_PATH = '/consultant';

export const consultantPaths = {
  updates: 'updates',
  triage: 'triage',
  clientOrganisations: 'client-organisations',
} as const;

export const adminPaths = {
  users: 'users',
  workspaces: 'workspaces',
  sharedKnowledge: 'shared-knowledge',
  regulatoryWatch: 'regulatory-watch',
  consultants: 'consultants',
  files: 'files',
  apiClients: 'api-clients',
} as const;

export const adminRegulatoryWatchPaths = {
  sources: 'sources',
  source_id_param: ':sourceId',
  references: 'references',
  reference_id_param: ':referenceId',
  updates: 'updates',
  update_id_param: ':updateId',
  institutions: 'institutions',
  countries: 'countries',
  scrape: 'scrape',
  discardedItems: 'discarded-items',
} as const;

export const paths = {
  ask: 'ask',
  chats: 'chats',
  projects: 'projects',
  tableViews: 'table-views',
  literatureReviews: 'literature-reviews',
  settings: 'settings',
  sources: 'sources',
  standards: 'standards', // Secret page - not in navigation
  regulatoryWatch: 'regulatory-watch',
  mcp: 'mcp',
} as const;

export const chatPaths = {
  chat_id_param: ':chat_id',
  /** Ask area: `/workspace/:w/ask/new` and `/workspace/:w/ask/history` */
  askNew: 'new',
  askHistory: 'history',
} as const;

export const standardsPaths = {
  chat_id_param: ':chat_id',
} as const;

export const projectPaths = {
  project_id_param: ':project_id',
} as const;

export const tableViewPaths = {
  tableView_id_param: ':tableView_id',
} as const;

export const regulatoryWatchPaths = {
  newsfeed: 'newsfeed',
  auditTable: 'audit-table',
  allUpdates: 'all-updates',
  allDocuments: 'all-documents',
  update_id_param: ':updateId',
  reference_id_param: ':referenceId',
} as const;

export const settingsPaths = {
  myAccount: 'my-account',
  companyProfile: 'company-profile',
  subscriptions: 'subscriptions',
  integrations: 'integrations',
} as const;

export const literatureReviewPaths = {
  literatureReview_id_param: ':literatureReview_id',
  steps: {
    search: 'search',
    abstractScreening: 'abstract-screening',
    fullTextScreening: 'full-text-screening',
  },
} as const;
